import * as React from 'react';
import { getAuthToken } from '../../../helper/get-auth-token';
import i18n from '../../../helper/i18n';
import { migrosLoginStatuses } from '../../../store/login';
import { LoginButtonProps } from './LoginButton.types';
import { nativeLogout } from './native-logout';

export function LoginButtonNative(props: LoginButtonProps) {
	const { isMigrosAuthenticated, doChangeMigrosLoginStatus, doClearRedirectRoutePath } = props;
	React.useEffect(() => {
		if (!isMigrosAuthenticated) {
			(async () => {
				// wait for native login is successfully completed
				await getAuthToken();
				// simulate successfully loggedin status
				doChangeMigrosLoginStatus(migrosLoginStatuses.AUTHENTICATED, true);
				doClearRedirectRoutePath();
				// doChangeMigrosLoginStatus(migrosLoginStatuses.AUTHENTICATED);
			})();
		}
	}, [doChangeMigrosLoginStatus, doClearRedirectRoutePath, isMigrosAuthenticated]);

	if (!props.isMigrosAuthenticated) {
		return null;
	}

	return (
		<div onClick={nativeLogout}>
			<a href="#">{i18n('react.impulsCoach.components.loginButton.logout')}</a>
		</div>
	);
}
